// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3W3vg","dragIcon":"Choice_dragIcon__FmQCB","left":"Choice_left__2CLA4","input":"Choice_input__1HmMy"};